<template>
    <div :ref="stepName" style="position:relative">
        <div class="form-header">
            <p>Veuillez entrer votre numéro de GSM</p>
            <p><span>Afin de sécuriser votre transaction, veuillez indiquer votre numéro de GSM dans le champ ci-dessous, un lien sécurisé vous sera envoyé.</span></p>
        </div>
        <PhoneForm></PhoneForm>
    </div>
</template>

<script>
import mixin from "../../../travel_step_mixin";
import PhoneForm from "./PhoneForm";
import animation_engine_mixin from "../../../animation_engine_mixin";
import animation_step_style_mixin from "../../../animation_step_style_mixin";

export default {
    components: { PhoneForm },
    mixins: [mixin,  animation_engine_mixin, animation_step_style_mixin],
}
</script>
